import DictionariesLoader from './DictionariesLoader';

export default DictionariesLoader;
